module.exports = __webpack_public_path__ + "static/media/muineTripadvisor2020.34879d9c.jpg";